import { VALIDATORS } from "./validators";

function transformAmountObject() {
    return Object.entries(window.app.amount_by_state.default).map(([key, value]) => {
        return {
            value: value,
            label: `$${value}`
        };
    });
};

const amountByStates = transformAmountObject();

export const blocks = {
    blocks: [
        {
            id: "step-0",
            name: "group",
            attributes: {
                label: "Choose Your Loan Options",
                nextBtnLabel: "Apply Now!",
            },
            innerBlocks: [
                {
                    id: "amount",
                    name: "custom-dropdown",
                    attributes: {
                        label: "Loan Amount",
                        required: true,
                        choices: amountByStates,
                        defaultValue: amountByStates.length > 1 ? amountByStates[1].value : amountByStates[0].value,
                    },
                },
                {
                    id: "period",
                    name: "custom-dropdown",
                    attributes: {
                        label: "Payback Period",
                        required: true,
                        choices: [
                            { value: "3:months", label: "3 Months" },
                            { value: "6:months", label: "6 Months" },
                            { value: "12:months", label: "12 Months" },
                        ],
                        defaultValue: "3:months",
                    },
                },
                {
                    id: "first_payment_date",
                    name: "date-picker",
                    attributes: {
                        label: "First Payment Date",
                        required: true,
                    },
                },
            ],
        },
        {
            id: "step-1",
            name: "group",
            attributes: {
                label: "Let's start!",
                nextBtnLabel: "Next",
            },
            innerBlocks: [
                {
                    id: "first_name",
                    name: "custom-short-text",
                    attributes: {
                        label: "First Name",
                        required: true,
                        placeholder: "John",
                        focusOnMount: true,
                        capitalize: true,
                    },
                },
                {
                    id: "middle_name",
                    name: "custom-short-text",
                    attributes: {
                        label: "Middle Name",
                        required: false,
                        placeholder: "Doe",
                        focusOnMount: true,
                        capitalize: true,
                    },
                },
                {
                    id: "last_name",
                    name: "custom-short-text",
                    attributes: {
                        label: "Last Name",
                        required: true,
                        placeholder: "Smith",
                        capitalize: true,
                    },
                },
            ],
        },
        {
            id: "step-2",
            name: "group",
            attributes: {
                label: "We would like to know more details about you!",
                nextBtnLabel: "Continue",
            },
            innerBlocks: [
                {
                    id: "contact_email",
                    name: "custom-email",
                    attributes: {
                        label: "Email",
                        required: true,
                        placeholder: "email@domain.com",
                    },
                },
                {
                    id: "phone_number",
                    name: "masked",
                    attributes: {
                        label: "Phone",
                        required: true,
                        placeholder: "(123) 456-7890",
                        mask: "(___) ___-____",
                        replacement: {
                            _: /\d/,
                        },
                        validators: [
                            {
                                validator: VALIDATORS.maskRequired("_"),
                                errorMessage: "Phone number is not valid!",
                            },
                        ],
                    },
                },
            ],
        },
        {
            id: "step-3",
            name: "group",
            attributes: {
                label: "Address Information",
                nextBtnLabel: "Continue",
            },
            innerBlocks: [
                {
                    id: "address",
                    name: "google-auto-complete",
                    attributes: {
                        label: "Address",
                        required: true,
                        placeholder: "123 Main St",
                        googleMapsApiKey: window.google_api_key ?? "AIzaSyA6NV06035QBpx6rKVvd-K9__oHbHvKwCQ",
                        cityInput: "city",
                        stateInput: "state",
                        zipInput: "zip",
                    },
                },
                {
                    id: "address2",
                    name: "custom-short-text",
                    attributes: {
                        label: "Suite/Apt",
                        placeholder: "Apt 1",
                    },
                },
                {
                    id: "city",
                    name: "custom-short-text",
                    attributes: {
                        label: "City",
                        required: true,
                        placeholder: "New York",
                    },
                },
                {
                    id: "state",
                    name: "masked",
                    attributes: {
                        label: "State",
                        required: true,
                        placeholder: "NY",
                        mask: "__",
                        replacement: {
                            _: /[A-Za-z]/,
                        },
                        uppercase: true,
                        validators: [
                            {
                                validator: VALIDATORS.length(2),
                                errorMessage: "State is not valid!",
                            },
                            {
                                validator: VALIDATORS.validState,
                                errorMessage: "State is not valid!",
                            },
                        ],
                    },
                },
                {
                    id: "zip",
                    name: "masked",
                    attributes: {
                        label: "Zip",
                        required: true,
                        placeholder: "12345",
                        mask: "_____",
                        replacement: {
                            _: /\d/,
                        },
                        validators: [
                            {
                                validator: VALIDATORS.maskRequired("_"),
                                errorMessage: "Zip is not valid!",
                            },
                        ],
                    },
                },
            ],
        },
        {
            id: "step-4",
            name: "group",
            attributes: {
                label: "Employment Information",
                nextBtnLabel: "Continue",
            },
            innerBlocks: [
                {
                    id: "employer",
                    name: "custom-short-text",
                    attributes: {
                        label: "Employer",
                        required: true,
                        placeholder: "Employer",
                        capitalize: true,
                    },
                },
                {
                    id: "months_employed",
                    name: "masked",
                    attributes: {
                        label: "Months at Employer",
                        required: true,
                        placeholder: "5",
                        mask: "   ",
                        replacement: { " ": /\d/ },
                    },
                },
                {
                    id: "pay_period",
                    name: "custom-dropdown",
                    attributes: {
                        label: "Pay Period",
                        required: true,
                        choices: [
                            { value: "weekly", label: "Weekly" },
                            { value: "biweekly", label: "Biweekly" },
                            { value: "monthly", label: "Monthly" },
                            { value: "semimonthly", label: "Semi-Monthly" },
                        ],
                        defaultValue: "biweekly",
                    },
                },
                {
                    id: "work_phone",
                    name: "masked",
                    attributes: {
                        label: "Work Phone",
                        required: true,
                        placeholder: "(123) 456-7890",
                        mask: "(___) ___-____",
                        replacement: {
                            _: /\d/,
                        },
                        validators: [
                            {
                                validator: VALIDATORS.maskRequired("_"),
                                errorMessage: "Work phone is not valid!",
                            },
                        ],
                    },
                },
            ],
        },
        {
            id: "step-5",
            name: "group",
            attributes: {
                label: "Employment Continuation",
                nextBtnLabel: "Continue",
            },
            innerBlocks: [
                {
                    id: "monthly_income",
                    name: "masked",
                    attributes: {
                        label: "Gross Monthly Income",
                        required: true,
                        placeholder: "$5000",
                        mask: "$     ",
                        replacement: {
                            " ": /\d/,
                        },
                        validators: [
                            {
                                validator: VALIDATORS.maskRequired("_"),
                                errorMessage: "Gross Monthly Income is not valid!",
                            },
                        ],
                    },
                },
                {
                    id: "income_source",
                    name: "multiple-choice",
                    attributes: {
                        choices: [
                            { value: "w2", label: "Employment (W2)" },
                            { value: "self", label: "Self-Employed" },
                            { value: "retired", label: "Retired" },
                            { value: "other", label: "Other" },
                        ],
                        verticalAlign: false,
                        required: true,
                    },
                },
            ],
        },
        {
            id: "step-6",
            name: "group",
            attributes: {
                label: "Housing Information",
                nextBtnLabel: "Continue",
            },
            innerBlocks: [
                {
                    id: "months_at_residence",
                    name: "masked",
                    attributes: {
                        label: "Months at Residence",
                        required: true,
                        placeholder: "5",
                        mask: "   ",
                        replacement: { " ": /\d/ },
                    },
                },
                {
                    id: "housing",
                    name: "multiple-choice",
                    attributes: {
                        choices: [
                            { value: "own", label: "Own" },
                            { value: "rent", label: "Rent" },
                        ],
                        verticalAlign: false,
                        required: true,
                    },
                },
            ],
        },
        {
            id: "step-7",
            name: "group",
            attributes: {
                label: "Personal Information",
                nextBtnLabel: "Continue",
            },
            innerBlocks: [
                {
                    id: "ssn",
                    name: "masked",
                    attributes: {
                        label: "Social Security Number",
                        required: true,
                        placeholder: "123-45-6789",
                        mask: "___-__-____",
                        replacement: {
                            _: /\d/,
                        },
                        validators: [
                            {
                                validator: VALIDATORS.maskRequired("_"),
                                errorMessage: "SSN is not valid!",
                            },
                        ],
                    },
                },
                // date of birth 3 boxes
                {
                    id: "date_of_birth",
                    name: "masked",
                    attributes: {
                        label: "Date of Birth",
                        required: true,
                        placeholder: "MM/DD/YYYY",
                        mask: "__/__/____",
                        replacement: {
                            _: /\d/,
                        },
                        validators: [
                            {
                                validator: VALIDATORS.maskRequired("_"),
                                errorMessage: "Date of Birth is not valid!",
                            },
                            {
                                // validate date format
                                validator: VALIDATORS.valid,
                                errorMessage: "Date of Birth is not valid!",
                            },
                            {
                                validator: VALIDATORS.olderThan(18),
                                errorMessage: "You must be at least 18 years old!",
                            },
                            {
                                validator: VALIDATORS.youngerThan(120),
                                errorMessage: "You must be younger than 120 years old!",
                            },
                        ],
                    },
                },
            ],
        },
        // {
        //   id: "step-8",
        //   name: "group",
        //   attributes: {
        //     label: "Create your account",
        //     nextBtnLabel: "Create Account",
        //   },
        //   innerBlocks: [
        //     {
        //       id: "password",
        //       name: "custom-short-text",
        //       attributes: {
        //         label: "Password",
        //         placeholder: "Password",
        //         required: true,
        //         type: "password",
        //       },
        //     },
        //     {
        //       id: "confirm-password",
        //       name: "custom-short-text",
        //       attributes: {
        //         label: "Password",
        //         placeholder: "Confirm Password",
        //         required: true,
        //         type: "password",
        //       },
        //     },
        //   ],
        // },
        // {
        //   id: "step-9",
        //   name: "statement",
        //   attributes: {
        //     buttonText: "OK",
        //     quotationMarks: false,
        //     statement: "Thank you for signing up!",
        //   },
        // },
    ],
};
